<template>
  <v-app>
    <v-container class="appclick">
      <Header>
        <font-awesome-icon :icon="['fas', 'diagnoses']" />
        <font-awesome-icon :icon="['fas', 'cogs']" />
        <font-awesome-icon :icon="['fas', 'filter']" />
        <span class="title">Object filter: traffic participant or not?</span>
      </Header>
      <v-form
        ><br /><br />

        <v-row class="rowbox1">
          <v-col class="col-4"> </v-col>
          <v-col class="col-1"> </v-col>
          <v-col class="col-4">
            <b>Number of objects unfiltered</b>
          </v-col>
          <v-col class="col-1">
            <b>{{ filter.filter_no }}</b>
          </v-col>
        </v-row>
        <v-row class="rowbox1">
          <v-col class="col-4">
            <b>Minimum number of frames per object</b><br /><span
              class="subtitle"
              >({{ field.field_fps }} frames = 1 second visible on screen)</span
            >
          </v-col>
          <v-col class="col-1">
            <v-text-field
              v-model="field.field_fpo"
              type="number"
              background-color="#42B98340"
              min="0"
              outlined
              @change="field_update('field_fpo', field.field_fpo)"
            >
            </v-text-field>
          </v-col>
          <v-col class="col-4">
            <b
              >Number of objects if number of frames >= {{ field.field_fpo }}</b
            >
          </v-col>
          <v-col class="col-1">
            <b>{{ filter.filter_fpo }}</b>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="col-4">
            <b>Minimum distance in pixels on video </b><br /><span
              class="subtitle"
            >
              (screen width {{ field.field_video_width }} pixels and heigth
              {{ field.field_video_height }} pixels)</span
            >
          </v-col>

          <v-col class="col-1">
            <v-text-field
              v-model="field.field_distance"
              type="number"
              background-color="#42B98340"
              min="0"
              outlined
              @change="field_update('field_distance', field.field_distance)"
            >
            </v-text-field>
          </v-col>
          <v-col class="col-4">
            <b
              >Number of objects if movement distance >=
              {{ field.field_distance }}</b
            >
          </v-col>
          <v-col class="col-1">
            <b>{{ filter.filter_distance }}</b>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="col-4"></v-col>
          <v-col class="col-1"></v-col>
          <v-col class="col-4">
            <b
              >Number of objects if number of frames >=
              {{ field.field_fpo }} AND<br />movement distance >=
              {{ field.field_distance }}
            </b>
          </v-col>
          <v-col class="col-1">
            <b>{{ filter.filter_both }}</b>
          </v-col>
        </v-row>
        <hr />
        <v-row>
          <v-col class="col-4">
            <v-subheader><b>Number of objects to test</b></v-subheader>
          </v-col>
          <v-col class="col-1">
            <v-text-field
              v-model="field.field_ntest_moving"
              type="number"
              background-color="#42B98340"
              min="0"
              max="50"
              outlined
              @change="
                field_update('field_ntest_moving', field.field_ntest_moving)
              "
            >
            </v-text-field>
          </v-col>

          <v-col class="col-2">
            <v-subheader>
              <router-link :to="{ name: 'settings_filter_moving' }"
                ><font-awesome-icon :icon="['fas', 'balance-scale']" /><span
                  class="title"
                  >Do test
                </span></router-link
              >
            </v-subheader>
          </v-col>
          <v-col class="col-2">
            <input
              type="radio"
              id="twee"
              v-model="field.field_filter_moving"
              value="0"
              @change="
                field_update('field_filter_moving', field.field_filter_moving)
              "
            />
            <label for="twee">Filter is inactive</label><br />
            <input
              type="radio"
              id="een"
              v-model="field.field_filter_moving"
              value="1"
              @change="
                field_update('field_filter_moving', field.field_filter_moving)
              "
            />
            <label for="een">Filter is active</label>
          </v-col>
        </v-row>
        <hr />
        <h6>Crossing number of frames * distance</h6>
        <div v-html="cross" id="tabel"></div>
      </v-form>
    </v-container>
  </v-app>
</template>
<script>
import ProjectService from "@/services/ProjectService.js";
import Header from "@/components/Header.vue";
export default {
  data() {
    return {
      field: {},
      filter: {}
    };
  },
  components: {
    //FilterActive,
    Header
  },
  mounted() {
    this.ApiGet();
  },
  methods: {
    ApiGet() {
      ProjectService.apiGet({
        nid: this.$session.get("PROJID"),
        type: "settings_filter"
      })
        .then(response => {
          console.log(response.data);
          this.field = response.data.fields;
          this.filter = response.data.filter[0];
          this.cross = response.data.cross;
        })
        .catch(error => {
          console.log("Fout " + error.response);
        });
    },
    field_update(field, value) {
      ProjectService.apiPost({
        nid: this.$session.get("PROJID"),
        type: "update_fields",
        field,
        value
      }).then(response => {
        if (response) this.ApiGet();
      });
    }
  }
};
</script>
<style scoped>
.subtitle {
  color: red;
  padding: 0;
  font-size: smaller;
}
.rowbox1 {
  border-bottom: 1px;
  height: 80px;
}
.col-middle {
  vertical-align: bottom;
  margin-top: 50px;
}
.Button {
  background: linear-gradient(to right, #16c0b0, #84cf6a);
}
</style>
